import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";

export class HasShareholderAgreementField extends Field<string> {
  constructor(model: Merchant, opts: Partial<MerchantField<string>> = {}) {
    super(model, {
      dataType: "string",
      testValue: "No",
      propertyName: "hasShareholderAgreement",
      pickList: ["Yes", "No"],
      uiFieldType: "Select",
      value: "No",
      ...opts,
    });
  }

  get applicable(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;
    const businessType = this._model.companyInformation.businessType.value;

    return (
      registeredCountry === "New Zealand" && businessType === "Private Company"
    );
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }
}
